import React, { useState } from 'react';
import { Formik } from 'formik'
import EditEventFormElement from './EditEventFormElement';
import EditEventFormButtons from './EditEventFormButtons';
import EditEventFormTextarea from './EditEventFormTextarea';
import getStatusSettings from '../func/getStatusSettings';
import getItemsWithPrice from '../func/getItemsWithPrice';
import EditEventMetaData from './EditEventMetaData';
import formatPrice from '../func/formatPrice';
import EditEventFormExtras from './EditEventFormExtras';
import getTotalPrice from '../func/getTotalPrice';
import EditEventFormPrint from './EditEventFormPrint';


const EditEventForm = ({status, error, event, eventInitValues, settings, currentLang, timezone, debug, checkChanges, onUpdateData, onCancel, onSendMail}) => {
    const [activeField, setActiveField] = useState('');
    const { form_layout, form_settings } = settings
    const { form_data, created_at, updated_at } =  event
    const elementItems = form_settings.element_types.items

    return (
        <Formik
            initialValues={eventInitValues}
            enableReinitialize={true}
            // onSubmit={(values, { setSubmitting, resetForm }) => {
            // }}
        >
            {({
                values,
                handleSubmit,
                setFieldValue
            }) => {
                const visitors = getItemsWithPrice(values, form_settings, "visitors", false);
                const visitorsFees = getItemsWithPrice(values, form_settings, "visitors_other_fees", visitors);
                const theatres = getItemsWithPrice(values, form_settings, "theatres", false);
                const theatresFees = getItemsWithPrice(values, form_settings, "theatres_other_fees", theatres);
                const totalTotal = getTotalPrice(visitors, visitorsFees, theatres, theatresFees, values.extra_price)

                return (
                    <form onSubmit={handleSubmit}>
                        <EditEventMetaData
                            values={values}
                            activeField={activeField}
                            setActiveField={setActiveField}
                            getStatusSettings={getStatusSettings}
                            created_at={created_at}
                            updated_at={updated_at}
                            eventName={event.form_data.name}
                        />

                        {form_layout.map(({name, element_types}, index) => (
                            <div className='edit-event-main' key={index}>
                                {element_types.map(elementId => <EditEventFormElement
                                    key={elementId}
                                    id={elementId}
                                    element={elementItems[elementId]}
                                    values={values}
                                    form_data={form_data}
                                    form_settings={form_settings}
                                    visitorsTotalNumber={visitors ? visitors.totalNumber : 0}
                                    theatresTotalNumber={theatres ? theatres.totalNumber : 0}
                                    activeField={activeField}
                                    setActiveField={setActiveField}
                                    setFieldValue={setFieldValue}
                                />)}
                            </div>
                        ))}

                        <EditEventFormExtras
                            values={values}
                            activeField={activeField}
                            setActiveField={setActiveField}
                        />
                        
                        <div className='total-total-box'>
                            <p className='total-total'>{'Gesamtsumme: ' + formatPrice(totalTotal) + ' €'}</p>
                        </div>

                        <div className='edit-event-summary'>
                            <p className='event-headline text-regular'>Zusammenfassung</p>
                            <EditEventFormPrint
                                eventData={values}
                                settings={settings}
                                currentLang={currentLang}
                                timezone={timezone}
                                debug={debug}
                                showInBrowser={true}
                            />
                        </div>

                        <EditEventFormTextarea
                            headline="Anschreiben"
                            name="cover_letter"
                        />

                        <EditEventFormButtons
                            request_id={event.request_id}
                            eventData={values}
                            settings={settings}
                            totalTotal={totalTotal}
                            hasChanges = {checkChanges(form_data, eventInitValues, values)}
                            transIdConfirmation="button_send_confirmation"
                            transIdMail="button_send_email"
                            transIdCancel="cancel_button"
                            transIdPDF="button_create_pdf"
                            transIdSubmit="save_content_button"
                            currentLang={currentLang}
                            timezone={timezone}
                            debug={debug}
                            onCancel={() => onCancel()}
                            onSubmit={() => onUpdateData(form_data, eventInitValues, values)}
                            onSendMail={() => onSendMail(form_data, eventInitValues, values)}
                        />
                    </form>
                );
            }}
        </Formik>
    )
}

export default EditEventForm